import { DataType, Config } from "./Content.interface";

export const hasData = (data: DataType) => {
    const type = typeof data;

    if (type === "string") {
        return !!data;
    }

    if (Array.isArray(data)) {
        return !!data?.length;
    }

    if (type === "object" && Object?.keys(data)?.length) {
        return Object?.keys(data)?.length !== 0;
    }

    console.warn("[complexComponent] can't determine type of data.", type);
    return true;
};

export const generateClasses = (config: Config) => {
    const classes: string[] = [];
    const baseClass = "complex-components__item";

    const type = baseClass + `__${config.type}`;
    const configClass = config.layout ? `config-${config.layout}` : "";

    classes.push(type);
    classes.push(configClass);

    const joined = classes.join(" ");

    return joined;
};
